// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1WKcF","empty":"ModalGraph_empty__K2Yq3"};